import { API } from 'aws-amplify';
import { ref } from 'vue';
import { PaymentMethod } from '@/payment-methods/payment-method.model';

const paymentMethods = ref<PaymentMethod[]>([]);

function fetchPaymentMethods() {
  return API.get('API', '/v1/payor/paymentMethods', {});
}

function deletePaymentMethod(paymentMethodId: string) {
  return API.del('API', `/v1/payor/paymentMethods/${paymentMethodId}`, {});
}

async function populatePaymentMethods() {
  paymentMethods.value = await fetchPaymentMethods();
}

export function usePaymentMethods() {
  return {
    paymentMethods,
    fetchPaymentMethods,
    populatePaymentMethods,
    deletePaymentMethod,
  }
}
